import { ErrorMessage, Field } from 'formik';
import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const InputTalento = ({index, errors, touched, setFieldValue, talentos, esEditable}) => {
    return (
        <Bootstrap.Form.Group as={Bootstrap.Col} md="3">
            <Bootstrap.Form.Label>
                <strong>Talento</strong>
            </Bootstrap.Form.Label>
            <Field
                name={`personaTalentos.${index}.talentoId`}
                as="select"
                className={`custom-select ${errors?.personaTalentos?.[index]?.talentoId && "is-invalid"}`}
                custom
                onChange={(e) => {
                    setFieldValue(
                        `personaTalentos.${index}.talentoId`,
                        Number(e.target.value)
                    );
                    if (!esEditable(e.target.value)) {
                        setFieldValue(
                            `personaTalentos.${index}.descripcion`,
                            talentos.find(
                                (x) => x.id == e.target.value
                            )?.descripcion
                        );
                    } else {
                        setFieldValue(
                            `personaTalentos.${index}.descripcion`,
                            ""
                        );
                    }
                }}
            >
                <option value={0} selected>Seleccione un talento</option>
                {talentos.map((talento) => (
                    <option key={talento.id} value={talento.id}>
                        {talento.descripcion}
                    </option>
                ))}
            </Field>
        </Bootstrap.Form.Group>
    )
}

export default InputTalento